<div class="live-dictation-wrapper">
  @if (isRecording()) {
    <app-recording-indicator [stream]="audioStream()" icon="mic" (stopClick)="toggleDictation()" />
  } @else {
    @if (loading()) {
      <mat-spinner diameter="18"></mat-spinner>
    } @else {
      <button mat-icon-button (click)="toggleDictation()" [matTooltip]="'Global.StartDictation' | translate">
        <mat-icon>speech_to_text</mat-icon>
      </button>
    }
  }
</div>
